import { AdminSession } from "../../../../domain/models";
import { AdminSessionEntity } from "../entities";

export default class AdminSessionMapper {
  static toModel(entity: AdminSessionEntity): AdminSession {
    return new AdminSession({
      token: entity.token
    })
  }
}